import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Box, Button, Container, FormField, Link, Popover, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiBallotOutline, mdiEyeOffOutline, mdiFileExcel } from '@mdi/js';
import { Icon } from '@mdi/react';
import { parse } from 'date-fns';
import * as XLSX from "xlsx";
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemPoll, ItemPollQuestion } from '../../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setLoading } from '../../../../commons/functions';


///private/admin/polls/update

export const CommPollsPage = () => {
  //const storeAdmin = useStoreAdmin();

  const { menu, data } = useGlobalState();



  const [polls, setPolls] = useState<ItemPoll[]>([]);
  const [questions, setQuestions] = useState<ItemPollQuestion[]>([]);
  const [idPoll, setIdPoll] = useState<number>(0);
  const [poll, setPoll] = useState<ItemPoll | null>(null);
  const [answers, setAnswers] = useState<[]>([]);


  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id) handleGetPoll(id ? parseInt(id) : 0);
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleGetPolls = async () => {
    setPoll(null)
    try {
      setLoading(true);


      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        //timeout: 600000,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/polls/list',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          orderBy: "dateOpen",
          order: "desc",
          orderBy2: "dateStart",
          order2: "desc"

        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.polls) {
        setPolls(data.polls);
      }

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }


  const handleGetPoll = async (idPoll: number) => {
    try {
      if (idPoll && idPoll > 0) {
        setLoading(true);


        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/polls/get',
            'JWT': getCookie("JWT"),

          },
          body: JSON.stringify({ idPoll: idPoll })
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }

        const data = await response.json();
        if (data && data.poll) {
          setPoll(data.poll);
          data.poll.questions.map((question: ItemPollQuestion) => {
            let q = question
            setQuestions((prevQuestions) => [...prevQuestions, q]);
          });
        }

      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
  }, []);

  useEffect(() => {
    handleGetPolls();
  }, []);


  const columns = [
    {
      id: "index",
      header: "",
      cell: (item: any) => item.index,
      width: 30
    },
    {
      id: "user",
      header: "Usuario",
      cell: (item: any) => item.dateAnswer !== "" ? <FormField constraintText={item.dateAnswer} label={item.displayName}></FormField> : item.displayName,
      maxWidth: 120,
    },
    ...(poll?.questions || []).map((q, index) => ({
      id: `q_${q.idQuestion}`,
      header:
        <Popover dismissButton={false}
          triggerType="custom"
          size="small"
          position="bottom"
          header={`${q.description === "" ? "" : q.question}`}
          content={<Box padding="s">{q.description === "" ? q.question : q.description}</Box>}>
          <BadgeCustom color="blue" fullWidth>{(index + 1).toString()}</BadgeCustom>
        </Popover>,
      cell: (item: Record<string, any>) => item[`q_${q.idQuestion}`] ? item[`q_${q.idQuestion}`] === "" ? "------" : item[`q_${q.idQuestion}`] : "------",
      maxWidth: 200,
    })),
  ];


  const usersMap: Record<
    number,
    { displayName: string;[key: string]: any }
  > = {};

  poll?.answers?.forEach((a) => {
    if (!usersMap[a.idUser]) {
      const user = getUser(a.idUser, data);
      usersMap[a.idUser] = {
        displayName: user?.displayName ?? `Usuario ${a.idUser}`,
        dateAnswer: a.dateAnswer ?? "",
      };
    }

    usersMap[a.idUser][`q_${a.idQuestion}`] =

      a.visibilityAnswer === -1 ? <><Icon path={mdiEyeOffOutline} size={1} /> Privado</> :
        a.answer === "" ? "------" : a.answer
  });

  const questionsMap: Record<number, { question: string;[key: string]: any }> = {};
  poll?.questions?.forEach(q => {
    questionsMap[q.idQuestion] = q;
  });

  const answersTemp: { [key: string]: string | JSX.Element | null }[] = [];
  Object.values(usersMap).forEach(userAnswers => {
    const row: { [key: string]: string | JSX.Element | null } = {};
    row['Nombre'] = userAnswers.displayName;
    for (const key in userAnswers) {

      if (key.startsWith('q_')) {
        const idQuestion = parseInt(key.substring(2));
        const question = questionsMap[idQuestion];
        if (question) {
          row[question.question] = question.visibilityQuestion === -1 ? "" : userAnswers[key] + "TEST";
        }
      }
    }
    answersTemp.push(row);
  });


  const parseCustomDate = (dateStr: string): number => {
    if (!dateStr) return 0;
    const parsedDate = parse(dateStr, "dd-MM-yyyy HH:mm", new Date());
    const time = parsedDate.getTime();
    return isNaN(time) ? 0 : time;
  };

  const sortedUsersArray = Object.entries(usersMap)
    .sort(([, a], [, b]) => {
      const dateA = parseCustomDate(a.dateAnswer);
      const dateB = parseCustomDate(b.dateAnswer);
      return dateA - dateB;
    })
    .map(([idUser, userData]) => ({
      idUser: Number(idUser),
      ...userData
    }));

  const rows = Object.values(sortedUsersArray.map((user: any, index: number) => ({
    ...user,
    index: index + 1
  })));

  function exportToExcelCustom() {
    const exportToExcel = () => {
      const wb = XLSX.utils.book_new();
      const pollData = poll.results;
      const allUserIds = Array.from(new Set(
        pollData.flatMap(q => q.answers.map((a: any) => a.idUser))
      ));

      const resume = allUserIds.map(userId => {
        // 1. "Usuario" is defined first, so it becomes the first column
        const row: Record<string, any> = {
          Usuario: getUser(userId, data)?.displayName ?? ""
        };

        // 2. Loop through questions to add the rest of the columns
        poll.results.forEach((q: any) => {
          const userAnswer = q.answers.find((a: any) => a.idUser === userId);
          row[q.question] = userAnswer ? userAnswer.answer : "";
        });

        return row;
      });
      const ws = XLSX.utils.json_to_sheet(resume);
      XLSX.utils.book_append_sheet(wb, ws, "PIVOT");
      poll.results.forEach((question: any, index: number) => {

        const answers = question.answers.map((q: any) => ({
          IDR: q.idAnswer,
          IDP: q.idQuestion,
          IDU: q.idUser,
          Usuario: getUser(q.idUser, data)?.displayName ?? "",
          Respuesta: q.answer
        }));

        const ws = XLSX.utils.json_to_sheet(answers || []);
        const sheetName = `Pregunta ${index + 1}`;
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
      });
      XLSX.writeFile(wb, `${poll.poll}.xlsx`);
    };
    exportToExcel();
  }
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          {!poll && (
            <>
              <Header variant="h1" actions={<>{!poll ? null : ""}{poll ? <Button variant="link" onClick={() => {
                setPoll(null)
                handleGetPolls()
              }}>Volver</Button> : ""}<Favorites /></>}>Inscripciones</Header>
              <Table items={polls}
                variant='embedded'
                columnDefinitions={[
                  {
                    id: 'poll', header: 'inscripción', cell: (item) =>
                      <FormField label={
                        <Link href={"#comm/polls/list?id=" + item.idPoll.toString()}>{item.poll}</Link>
                      }>
                        {item.description.length > 80 ? item.description.substring(0, 80) + "…" : item.description}
                      </FormField>

                  },
                  {
                    id: 'dateStart', header: 'Inicio', cell: (item) =>
                      <FormField label={item.dateStart}>
                        <Box variant="awsui-key-label">{item.timeStart}</Box>
                      </FormField>
                  },
                  {
                    id: 'dateEnd', header: 'Finalización', cell: (item) =>

                      <FormField label={item.dateClose}>
                        <Box variant="awsui-key-label">{item.timeClose}</Box>
                      </FormField>
                  },
                  {
                    id: 'votes', header: <Icon path={mdiBallotOutline} size={1} />, cell: (item) => item.totalUsers,
                    width: 90
                  },
                ]} />
            </>
          )}
          {poll && (
            <SpaceBetween size="s">
              <Header variant="h2"

                actions={<SpaceBetween direction="horizontal" size="xs">
                  {poll ? <Button variant='link' onClick={() => {
                    setPoll(null)
                    handleGetPolls()
                    window.location.hash = '#comm/polls/list';
                  }}>Volver</Button> : ""}

                  {poll.publicResults === 1 && (
                    <BadgeCustom color={poll.totalUsers === 0 ? "light" : "blue"}>{poll.totalUsers === 0 ? "Sin inscritos" : `Inscrito${poll.totalUsers > 1 ? "s" : ""}: ${poll.totalUsers}`}</BadgeCustom>
                  )}

                </SpaceBetween>}
              >{poll.poll}</Header>

              {poll.description && poll.description !== "" && (

                <Container>
                  <div
                    style={{ marginBottom: '16px' }}
                    dangerouslySetInnerHTML={{
                      __html: poll.description.replace(/\n/g, "<br>"),
                    }}
                  />
                </Container>
              )}
              {poll.hasEnded === 0 && (
                <Box variant="p">Fecha de cierre: {poll.dateClose} a las {poll.timeClose}</Box>
              )}
              {poll.hasStarted === 0 && (
                <Alert type="info" header="La inscripción no está activa" dismissible={false}></Alert>
              )}
              {poll.hasEnded === 1 && (
                <Alert type="info" header="La inscripción ha finalizado" dismissible={false}></Alert>
              )}
              {poll && poll.publicAnswers === 0 && (
                <Alert type="error" header="Respuestas privadas" dismissible={false}></Alert>
              )}
              {poll.hasStarted === 1 && poll.publicAnswers === 1 && (
                <Table
                  cellVerticalAlign='top'
                  wrapLines
                  stickyColumns={{
                    first: 1,
                    last: 0
                  }}

                  columnDefinitions={columns}
                  items={rows}
                  header={<Header variant='h3'
                    actions={
                      <Button disabled={!poll} onClick={() => exportToExcelCustom()} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>}
                  >Resultados de inscripciones</Header>}
                  stickyHeader
                  variant="full-page"
                />
              )}
            </SpaceBetween>
          )}
        </SpaceBetween >
      }
    />
  );
};